module.exports = __webpack_public_path__ + "static/flavors-b718b45255ad377c2bd2dfa42b231a26.png";